// oxlint-disable-next-line eslint/no-redeclare
export const ApplicationModes = {
	Unified: 'unified',
	Rovo: 'rovo',
} as const;
export type ApplicationModes = (typeof ApplicationModes)[keyof typeof ApplicationModes];
